import B64 from '@/filters/base64'
import Frames from '@/components/frames/component'

export default {
  name: 'cart-component',
  components: { Frames },
  props: [ 'simple', 'show-shipping' ],

  data () {
    return {
      isShowing: false,
      window: {
        width: 0,
        height: 0,
      },
      cartSummaryHeight: 0,
    }
  },
  created () {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize);
  },
  mounted () {
    // Show the cart if we just want the plain one (with no icon or functionality, just the cart straight up).
    if (this.simple === true) {
      this.isShowing = true
    }

    if (this.$route.name === 'checkout') {
      this.$store.dispatch('trackViewFrames', {
        list: 'checkout',
        frames: this.frames
      })
    }
  },

  computed: {
    items () {
      return this.$store.getters.cartItems
    },

    itemCount () {
      let ret = 0
      this.items.forEach(function (item) {
        ret += item.count
      })
      return ret
    },

    subtotal () {
      return this.$store.getters.cartSubTotal
    },

    frames () {
      const ret = []
      let metadata = this.$store.getters.productsMetadata
      Object.entries(metadata).forEach((item) => {
        if (item[1].type === 'frame' || item[1].type === 'hanger') {
          ret.push(item[1])
        }
      })
      return ret
    },

    itemsMaxHeight () {
      if (this.cartSummaryHeight === 0) {
        return 200;
      }
      const menuContainer = document.getElementsByClassName('menu-container');
      let menuContainerHeight = 0;
      if (menuContainer.length > 0) {
        menuContainerHeight = menuContainer[0].offsetHeight;
      }
      return this.window.height - menuContainerHeight - this.cartSummaryHeight - (menuContainerHeight < 60 ? 60 : 80);
    }
  },

  methods: {
    toggle () {
      this.isShowing = !this.isShowing

      // When we take action in the cart, move the backdrop into the corresponding state.
      this.$store.dispatch('showBackdrop', this.isShowing)
    },

    close () {
      this.isShowing = false

      // When we take action in the cart, move the backdrop into the corresponding state.
      this.$store.dispatch('showBackdrop', this.isShowing)
    },

    goToBirthPosters () {
      if (this.isShowing) {
        this.toggle()
      }
      this.$router.push({ name: 'posters' })
    },

    goToDoodleArt () {
      if (this.isShowing) {
        this.toggle()
      }
      this.$router.push({ name: 'doodleArt' })
    },

    remove (index) {
      this.$store.dispatch('removeItem', index)
    },

    goToCheckout () {
      // Hide cart and backdrop.
      this.isShowing = false
      this.$store.dispatch('showBackdrop', false)

      // Go to the checkout.
      this.$router.push({ name: 'checkout' })
    },

    getPosterHTML (item) {
      return item.svgB64 ? B64.decode(item.svgB64) : ''
    },

    decrement (index) {
      this.$store.dispatch('decrementItem', index)
    },

    increment (index) {
      this.$store.dispatch('incrementItem', index)
    },

    handleResize () {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
  },

  watch: {
    isShowing (newVal) {
      if (newVal === true) {
        this.$nextTick(() => {
          const cartSummary = document.getElementsByClassName('cart-summary');
          this.cartSummaryHeight = 0;
          if (cartSummary && cartSummary.length > 0) {
            this.cartSummaryHeight = cartSummary[0].offsetHeight;
          }
        });
      }
    },
    // Close the cart if we close the backdrop.
    '$store.getters.backdropIsShowing' () {
      if (!this.$store.getters.backdropIsShowing && !this.simple) {
        this.isShowing = false
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/cart/script.js